import React, { useState, useEffect, useRef, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
   Box,
   Button,
   CardContent,
   Container,
   Divider,
   Grid,
   Typography,
   TextField
} from '@material-ui/core'
// import Remove from '@material-ui/icons/Remove'
// import Add from '@material-ui/icons/Add'
import Download from '@material-ui/icons/Download'

// API
import { getPublicAPI, postPublicAPI } from '../api'

// components
import logo from '../assets/images/logo.jpg'
import Loader from '../components/utils/Loader'
import SearchResult from '../components/SearchResult'

// Barcode
import BarCodeScanner from '../components/barcode-scanner'
import Barcode from 'react-barcode'

// context
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import { ToastContext } from '../contexts/Toast'

const Product = () => {
   let mounted = useRef(true)

   const navigate = useNavigate()
   const { product } = useParams()

   const { shopping, setShopping, setProductRoute, searchC } = useContext(ShoppingCartContext)
   const { setToasts } = useContext(ToastContext)

   const [loading, setLoading] = useState(true)
   const [image, showImage] = useState(false)
   const [selectedIndex, setSelectedIndex] = useState(0)
   const [productData, setProductData] = useState(null)
   const [quantity, setQuantity] = useState(0)

   const [feets, setFeets] = useState(0)
   const [inches, setInches] = useState(0)

   const [productPrice, setProductPrice] = useState()
   const [isPriceDiscounted, setIsDiscounted] = useState(false)

   const onQuantityChange = value => {
      setQuantity(value || 0)

      const myQuantity = document.getElementById('quantity-' + productData?.rhpn)
      if (myQuantity)
         myQuantity.addEventListener('keypress', function (evt) {
            let value = myQuantity.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })
   }
   const onFeetsChange = value => {
      setFeets(value || 0)

      const myFeets = document.getElementById('feets-' + productData?.rhpn)
      if (myFeets)
         myFeets.addEventListener('keypress', function (evt) {
            let value = myFeets.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })
   }
   const onInchesChange = value => {
      setInches(value || 0)

      const myInches = document.getElementById('inches-' + productData?.rhpn)
      if (myInches)
         myInches.addEventListener('keypress', function (evt) {
            let value = myInches.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })
   }

   var recentItem = JSON.parse(localStorage.getItem('recent'))
   recentItem?.push(product)
   var recent = recentItem?.reverse()
   let unique = [...new Set(recent)]
   var reverse = unique.reverse()
   localStorage.setItem('recent', JSON.stringify(reverse))

   const addToCart = async () => {
      // mounted.current && setCart(false)

      if (productData?.type === 'hose' && feets === 0 && inches === 0) return
      if (productData?.type !== 'hose' && quantity === 0) return

      try {
         let quantityInfo = productData?.type === 'hose' ? feets + '-' + inches : quantity

         const data = {
            quantity: quantityInfo,
            productId: product,
            user: localStorage.user_email || localStorage.ip_address
         }

         let addedToCart = await postPublicAPI('/add-to-cart', data)
         if (addedToCart?.success) {
            setToasts({
               type: 'success',
               messages: [{ msg: `${product} added to cart` }]
            })

            setShopping(!shopping)
         } else
            setToasts({
               type: 'error',
               messages: addedToCart?.errors
            })
      } catch (err) {
         setToasts({
            type: 'error',
            messages: [{ msg: `error in adding to cart ${err.message}` }]
         })
      } finally {
         // mounted.current && setCart(true)
         mounted.current && setQuantity(0)
         mounted.current && setFeets(0)
         mounted.current && setInches(0)
      }
   }

   let customerId = localStorage.getItem('user_id')
   useEffect(() => {
      setTimeout(() => {
         // if (!localStorage.auth_token) navigate('/login')
         mounted.current && setLoading(false)
      }, 1000)

      const prepareProduct = async () => {
         let fetchProductData = await getPublicAPI('/get-product', { product })
         if (fetchProductData?.success && mounted.current) {
            setProductData(fetchProductData?.data)

            if (localStorage.auth_token) {
               let userData = await getPublicAPI(`/user/${customerId}`)
               if (userData?.success) {
                  if (userData?.data?.discountValue && userData?.data?.discountValue > 0)
                     setIsDiscounted(true)

                  let calculatedPrice =
                     (fetchProductData?.data?.lPrice * userData?.data?.discountValue) / 100
                  let discountedPrice = Math.round(calculatedPrice * 100) / 100
                  let newPrice = (fetchProductData?.data?.lPrice - discountedPrice).toFixed(2)
                  setProductPrice(newPrice)
               }
            }
         } else
            setToasts({
               type: 'error',
               messages: fetchProductData?.errors
            })
      }

      prepareProduct()
      setProductRoute(product)
      return () => (mounted.current = false)
   }, [navigate, product, setToasts, customerId])

   const downloadBarcode = () => {
      let base64Barcode = document.getElementById('product-barcode').childNodes

      let linkSource =
         'data:application/octet-stream;base64,' +
         base64Barcode[0].currentSrc.replace(/^data:image\/(png|gif|jpeg);base64,/, '')

      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = productData?.rhpn + '.jpg'
      downloadLink.click()
   }

   useEffect(() => {
      const myQuantity = document.getElementById('quantity-' + productData?.rhpn)
      if (myQuantity)
         myQuantity.addEventListener('keypress', function (evt) {
            let value = myQuantity.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      const myFeets = document.getElementById('feets-' + productData?.rhpn)
      if (myFeets)
         myFeets.addEventListener('keypress', function (evt) {
            let value = myFeets.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })

      const myInches = document.getElementById('inches-' + productData?.rhpn)
      if (myInches)
         myInches.addEventListener('keypress', function (evt) {
            let value = myInches.value.toString()
            if (value[0] === '0') {
               evt.preventDefault()
            }
            if (evt.which < 48 || evt.which > 57) {
               evt.preventDefault()
            }
         })
   }, [productData?.rhpn])

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : `${product} | The HosePod`}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               ) : searchC ? (
                  <SearchResult />
               ) : (
                  <Box>
                     <Box className='product-head-container'>
                        <Typography sx={{ mb: 2 }}>Home / Products / {product}</Typography>
                        <BarCodeScanner />
                     </Box>
                     {productData ? (
                        <Box className='product-container'>
                           <Box className='product-images-list'>
                              {productData?.pictures?.length > 0 ? (
                                 <>
                                    {productData?.pictures.map((image, index) => (
                                       <CardContent
                                          onClick={() => setSelectedIndex(index)}
                                          // onMouseOver={() => setSelectedIndex(index)}
                                          key={index}
                                       >
                                          <img
                                             className='product-images'
                                             alt={product + index}
                                             src={image || logo}
                                          />
                                       </CardContent>
                                    ))}
                                 </>
                              ) : (
                                 <Typography variant='h3' color='#d22f25' textAlign='center'>
                                    No pictures
                                 </Typography>
                              )}
                           </Box>
                           <CardContent
                              onClick={() => showImage(true)}
                              sx={{ justifySelf: 'center' }}
                           >
                              <img
                                 className='product-image'
                                 alt={product}
                                 src={
                                    productData?.pictures?.length > 0
                                       ? productData?.pictures[selectedIndex]
                                       : logo
                                 }
                              />
                           </CardContent>
                           <Box>
                              <Typography color='textPrimary' gutterBottom className='part-number'>
                                 {'Part #: ' + productData?.rhpn}
                              </Typography>
                              <Typography color='action' className='part-detail'>
                                 {productData?.rhpn + ' | ' + productData?.desc}
                              </Typography>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '2vw',
                                    marginBottom: '1vw'
                                 }}
                              >
                                 <Box>
                                    {productData?.type === 'hose' ? (
                                       <Typography variant='h3'>
                                          Price per feet: $
                                          {isPriceDiscounted ? productPrice : productData?.lPrice}
                                       </Typography>
                                    ) : (
                                       <Typography variant='h3'>
                                          Price: $
                                          {isPriceDiscounted ? productPrice : productData?.lPrice}
                                       </Typography>
                                    )}
                                    {(quantity && quantity > 0) ||
                                    (feets && feets > 0) ||
                                    (inches && inches > 0) ? (
                                       <>
                                          {isPriceDiscounted ? (
                                             <Box>
                                                <Typography
                                                   color='secondary'
                                                   className='part-detail'
                                                   style={{
                                                      textDecoration: 'line-through',
                                                      color: 'gray'
                                                   }}
                                                >
                                                   {productData?.type === 'hose'
                                                      ? '$' +
                                                        (
                                                           (parseFloat(feets) +
                                                              parseFloat(inches) / 12) *
                                                           parseFloat(productPrice)
                                                        ).toFixed(2)
                                                      : '$' +
                                                        (
                                                           parseFloat(quantity) *
                                                           parseFloat(productPrice)
                                                        ).toFixed(2)}
                                                </Typography>
                                                <Typography
                                                   color='secondary'
                                                   className='part-detail'
                                                >
                                                   {productData?.type === 'hose'
                                                      ? '$' +
                                                        (
                                                           (parseFloat(feets) +
                                                              parseFloat(inches) / 12) *
                                                           parseFloat(productPrice)
                                                        ).toFixed(2)
                                                      : '$' +
                                                        (
                                                           parseFloat(quantity) *
                                                           parseFloat(productPrice)
                                                        ).toFixed(2)}
                                                </Typography>
                                             </Box>
                                          ) : (
                                             <Typography color='secondary' className='part-detail'>
                                                {productData?.type === 'hose'
                                                   ? '$' +
                                                     (
                                                        (parseFloat(feets) +
                                                           parseFloat(inches) / 12) *
                                                        parseFloat(productData?.lPrice)
                                                     ).toFixed(2)
                                                   : '$' +
                                                     (
                                                        parseFloat(quantity) *
                                                        parseFloat(productData?.lPrice)
                                                     ).toFixed(2)}
                                             </Typography>
                                          )}
                                       </>
                                    ) : (
                                       <></>
                                    )}
                                 </Box>
                                 <Button variant='outlined'>Bulk Discounts</Button>
                              </Box>
                              <Divider />
                              {(localStorage.user_type === 'customer' ||
                                 (localStorage.ip_address && !localStorage.auth_token)) && (
                                 <Box className='product-info-bottom'>
                                    {productData?.type === 'hose' ? (
                                       <Box>
                                          {/* <Typography
                                             color='#D22F25'
                                             display='inline'
                                             variant='body1'
                                          >
                                             Feets:
                                          </Typography>
                                          <Grid
                                             container
                                             sx={{
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                mb: 2
                                             }}
                                          >
                                             <Button
                                                className='product-actions'
                                                item='true'
                                                onClick={onDecrement}
                                                variant='contained'
                                             >
                                                <Remove color='textPrimary' />
                                             </Button>
                                             <Grid>
                                                <Typography
                                                   color='#D22F25'
                                                   display='inline'
                                                   variant='body1'
                                                >
                                                   {feets}
                                                </Typography>
                                             </Grid>
                                             <Button
                                                className='product-actions'
                                                item='true'
                                                onClick={onIncrement}
                                                variant='contained'
                                             >
                                                <Add color='textPrimary' />
                                             </Button>
                                          </Grid>
                                          <Typography
                                             color='#D22F25'
                                             display='inline'
                                             variant='body2'
                                          >
                                             Inches:
                                          </Typography>
                                          <Grid
                                             container
                                             sx={{
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                             }}
                                          >
                                             <Button
                                                className='product-actions'
                                                item='true'
                                                onClick={onInchDecrement}
                                                variant='contained'
                                             >
                                                <Remove color='textPrimary' />
                                             </Button>
                                             <Grid>
                                                <Typography
                                                   color='#D22F25'
                                                   display='inline'
                                                   variant='body2'
                                                >
                                                   {inches}
                                                </Typography>
                                             </Grid>
                                             <Button
                                                className='product-actions'
                                                item='true'
                                                onClick={onInchIncrement}
                                                variant='contained'
                                             >
                                                <Add color='textPrimary' />
                                             </Button>
                                          </Grid> */}
                                          <Typography
                                             color='#D22F25'
                                             display='inline'
                                             variant='body2'
                                          >
                                             Please fill in the length:
                                          </Typography>
                                          <Grid
                                             container
                                             sx={{
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                mb: 2,
                                                mt: 2
                                             }}
                                          >
                                             <TextField
                                                id={`feets-${productData?.rhpn}`}
                                                label='Feets'
                                                fullWidth
                                                value={feets || ''}
                                                autoComplete={false}
                                                onChange={e => {
                                                   if (
                                                      (e.target.value === '0' && inches === '0') ||
                                                      (e.target.value === '0' && inches === '')
                                                   ) {
                                                      setToasts({
                                                         type: 'error',
                                                         messages: [
                                                            { msg: 'Enter a value of atleast 1' }
                                                         ]
                                                      })
                                                   }
                                                   onFeetsChange(e.target.value)
                                                }}
                                             />
                                          </Grid>
                                          <Grid
                                             container
                                             sx={{
                                                justifyContent: 'space-between',
                                                alignItems: 'center'
                                             }}
                                          >
                                             <TextField
                                                id={`inches-${productData?.rhpn}`}
                                                label='Inches'
                                                fullWidth
                                                value={inches || ''}
                                                autoComplete={false}
                                                onChange={e => {
                                                   if (
                                                      (e.target.value === '0' && feets === '0') ||
                                                      (e.target.value === '0' && feets === '')
                                                   ) {
                                                      setToasts({
                                                         type: 'error',
                                                         messages: [
                                                            { msg: 'Enter a value of atleast 1' }
                                                         ]
                                                      })
                                                   }
                                                   onInchesChange(e.target.value)
                                                }}
                                             />
                                          </Grid>
                                       </Box>
                                    ) : (
                                       <Grid
                                          container
                                          sx={{
                                             justifyContent: 'space-between',
                                             alignItems: 'center'
                                          }}
                                       >
                                          {/* <Button
                                             className='product-actions'
                                             item='true'
                                             onClick={onDecrement}
                                             variant='contained'
                                          >
                                             <Remove color='textPrimary' />
                                          </Button>
                                          <Grid>
                                             <Typography
                                                color='#D22F25'
                                                display='inline'
                                                variant='body2'
                                             >
                                                {quantity}
                                             </Typography>
                                          </Grid>
                                          <Button
                                             className='product-actions'
                                             item='true'
                                             onClick={onIncrement}
                                             variant='contained'
                                          >
                                             <Add color='textPrimary' />
                                          </Button> */}
                                          <Typography
                                             color='#D22F25'
                                             display='inline'
                                             variant='body2'
                                             sx={{ mb: 2 }}
                                          >
                                             Please fill in the quantity:
                                          </Typography>
                                          <TextField
                                             id={`quantity-${productData.rhpn}`}
                                             label='Quantity'
                                             fullWidth
                                             value={quantity || ''}
                                             autoComplete={false}
                                             onChange={e => {
                                                if (e.target.value === '0')
                                                   setToasts({
                                                      type: 'error',
                                                      messages: [
                                                         { msg: 'Enter a value of atleast 1' }
                                                      ]
                                                   })

                                                onQuantityChange(e.target.value)
                                             }}
                                          />
                                       </Grid>
                                    )}
                                    <Button
                                       onClick={addToCart}
                                       disabled={
                                          !(
                                             (quantity && quantity > 0) ||
                                             (feets && feets > 0) ||
                                             (inches && inches > 0)
                                          )
                                       }
                                       sx={{ height: '5vh' }}
                                       variant='contained'
                                    >
                                       Add to Cart
                                    </Button>
                                 </Box>
                              )}
                              {productData?.rhpn && (
                                 <Box sx={{ display: 'flex' }} id='product-barcode'>
                                    <Barcode
                                       format='CODE128'
                                       width={2}
                                       height={100}
                                       renderer={'img'}
                                       value={productData?.rhpn}
                                    />
                                    <Button onClick={downloadBarcode}>
                                       <Download color='textPrimary' />
                                    </Button>
                                 </Box>
                              )}
                           </Box>
                           {image && (
                              <Box
                                 className='expanded-image-container'
                                 sx={{
                                    position: 'absolute',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    background: '#f4f4f4',
                                    pb: 5
                                 }}
                              >
                                 <Button
                                    onClick={() => showImage(false)}
                                    className='cross-expanded'
                                 >
                                    X
                                 </Button>
                                 <img
                                    className='product-image-expanded'
                                    alt={product}
                                    src={
                                       productData?.pictures?.length > 0
                                          ? productData?.pictures[selectedIndex]
                                          : logo
                                    }
                                 />
                              </Box>
                           )}
                        </Box>
                     ) : (
                        <Typography
                           sx={{
                              fontSize: '30px',
                              fontWeight: '500',
                              textAlign: 'center',
                              color: '#D22F25',
                              mt: 10
                           }}
                        >
                           Product details not available
                        </Typography>
                     )}
                  </Box>
               )}
            </Container>
         </Box>
      </>
   )
}

export default Product
